export default __webpack_public_path__ + "static/media/Mercenary's Bracers of Crouching Calm.ae9351af.jpg";